import React from "react";
import Chatbot from "components/chat-bot/chat-bot";
import { useActivePartnerProvider } from "data/active-partner-provider/hooks";
import page from "page";
import AIConsent from "../../../components/chat-bot/ai-consent";

export const ChatPage = (props) => {
  const { partner } = useActivePartnerProvider();

  React.useEffect(() => {
    if (false == partner.aiEnabled) {
      page("/");
    }
  }, [partner]);

  if (!partner.aiEnabled) {
    return null;
  }

  if (!partner.aiConsent) {
    return <AIConsent />;
  }

  return <Chatbot {...props} />;
};
